import React from 'react'

// Components Global
import { LayoutsDesignDisplay } from '../../../LayoutsDesign'


const WidgetsDisplay = (props) => {
  const { business, setting, site, pages, pageCurrent, singlePageData } = props.datas

  return (
    <LayoutsDesignDisplay
      {...props}
      display
      widgets
      action={{
        params: {
          business,
          setting,
          site,
          pages,
          data: singlePageData ? singlePageData : site,
          pageCurrent,
          _id: singlePageData ? singlePageData._id : site._id,
          templateData: singlePageData ? singlePageData : site,
        }
      }}
    />
  )
}

export default WidgetsDisplay
